import React from 'react';

const SvgMedal = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.2713 10.4449L17.9995 1.99995L14.2713 10.4449ZM9.31563 10.6322L4.99951 1.99995L9.31563 10.6322ZM12.761 10.0478L8.83451 1.99995L12.761 10.0478ZM14.3595 1.99995L13.3195 4.49995L14.3595 1.99995ZM5.99951 15.9999C5.99951 19.3136 8.6858 21.9999 11.9995 21.9999C15.3132 21.9999 17.9995 19.3136 17.9995 15.9999C17.9995 12.6862 15.3132 9.99995 11.9995 9.99995C8.6858 9.99995 5.99951 12.6862 5.99951 15.9999Z" stroke="white" strokeWidth="1.66718" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default SvgMedal;
